import { FrontendPageEnum } from "shared/model/pages";

import { Chat } from "../routes/chat";
import { Journey } from "../routes/journey";
import { RouteWithTitle } from "../util/metadata-for-active-route";

export type MainRoute = Omit<RouteWithTitle, "path"> & {
  hideInNavbar?: boolean;
};

export const frontendPages: {
  [page in FrontendPageEnum]: MainRoute;
} = {
  [FrontendPageEnum.CHAT]: {
    title: { tx: "chat.headerTitle" },
    element: <Chat />,
  },
  [FrontendPageEnum.JOURNEY]: {
    title: { tx: "journey.headerTitle" },
    element: <Journey />,
  },
};
